import { gql } from '@apollo/client';

const TODO_ITEM_FIELDS = gql`
  fragment TodoItemFields on TodoItem {
    id
    type
    kitchen
    title
    occurredAt
    videoReview {
      camera
      room
      peopleCount
    }
  }
`;

const VIDEO_REVIEW_FIELDS = gql`
  fragment VideoReviewFields on VideoReview {
    id
    digest
    camera
    room
    recordedAt
    people {
      segments {
        action
        startMs
        endMs
        reason
      }
      durationMs
      pastWords
      rounds
      canGiveWords
    }
    maxRevisions
    limits {
      maxNoteChars
      maxNoteAudioSeconds
    }
  }
`;

export const LIST_MY_TODOS_QUERY = gql`
  ${TODO_ITEM_FIELDS}
  query ListMyTodos($kitchen: Kitchen!) {
    listMyTodos(kitchen: $kitchen) {
      ...TodoItemFields
    }
  }
`;

export const GET_VIDEO_REVIEW_QUERY = gql`
  ${VIDEO_REVIEW_FIELDS}
  query GetVideoReview($id: ID!) {
    getVideoReview(id: $id) {
      ...VideoReviewFields
    }
  }
`;

export const GET_VIDEO_REVIEW_CLIP_URL_QUERY = gql`
  query GetVideoReviewClipUrl($id: ID!) {
    getVideoReviewClipUrl(id: $id) {
      url
      expiresInSeconds
      fps
      frameWidth
      frameHeight
      people {
        firstFrame
        lastFrame
        boxes {
          frame
          x1
          y1
          x2
          y2
        }
      }
    }
  }
`;

export const SUBMIT_VIDEO_REVIEW_MUTATION = gql`
  mutation SubmitVideoReview($input: SubmitVideoReviewInput!) {
    submitVideoReview(input: $input)
  }
`;

export const SKIP_VIDEO_REVIEW_MUTATION = gql`
  mutation SkipVideoReview($id: ID!) {
    skipVideoReview(id: $id)
  }
`;

export const TRANSCRIBE_VIDEO_REVIEW_WORDS_MUTATION = gql`
  mutation TranscribeVideoReviewWords($audio: VideoReviewAudioInput!) {
    transcribeVideoReviewWords(audio: $audio) {
      text
    }
  }
`;
